import { render, staticRenderFns } from "./ExamRandomDo.vue?vue&type=template&id=20ae5f0c"
import script from "./ExamRandomDo.vue?vue&type=script&lang=js"
export * from "./ExamRandomDo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports